import React from 'react'
import { FlexBox, FluidImage, Link, Span, Typography } from '@vp/swan'
import type { BrandItem } from '../../../../types/site-header'
import { getHeaderTracker } from '../../../../tracking'
import { TOP_BAR } from '../../../../constants/analytics'

type BottomMobileMenuProps = {
  brands: BrandItem[]
  brandsDesktop: BrandItem[]
  brandsHeading: string
}

const BottomMobileMenu: React.FC<BottomMobileMenuProps> = ({ brands, brandsDesktop, brandsHeading }) => {
  const brandsToDisplay = brandsDesktop?.length ? brandsDesktop : brands
  const hasBrands = brandsToDisplay?.length > 0
  if (!hasBrands) return null

  const handleBrandClick = (analyticsId: string | undefined, url: string) => {
    getHeaderTracker().trackLink({
      subSection: TOP_BAR,
      navigationDetailPath: analyticsId ? [analyticsId] : [],
      href: url,
    })
  }

  /* negative margin to overwrite padding by container */
  return (
    <FlexBox gap={5} flexDirection="column" px={5} py={6} backgroundColor="strong" style={{ margin: '0 -14px -14px -14px' }}>
      <Typography fontSkin="title-item" textColor="standard">
        {brandsHeading}
      </Typography>
      {brandsToDisplay?.map((brand) => (
        <Link key={brand.text} href={brand.url} skin="unstyled" onClick={() => handleBrandClick(brand.analyticsId, brand.url)}>
          {brand.image?.url ? (
            <FluidImage src={brand.image.url} alt={brand.text} loading="lazy" decoding="async" style={{ maxHeight: '30px', width: 'auto' }} />
          ) : (
            <Span fontSkin="body-small" textColor="standard">
              {brand.text}
            </Span>
          )}
        </Link>
      ))}
    </FlexBox>
  )
}

export default BottomMobileMenu
